// This file (and its related code) was extracted from `src/rxdb/syncReplicationStatesWithGraphQL.ts`
import { replicateBorerOperatorChange } from '../BorerOperatorChangeFeed/replicateBorerOperatorChange';
import { replicateBorerOperatorState } from '../BorerOperatorStateFeed/replicateBorerOperatorState';
import { Database } from '../Database';
import { ConfigBuilder, ReplicationState } from '../replicate';
import { handleOperatorStateFeedEvents } from './handleOperatorStateFeedEvents';

export function replicateBorerOperator(
  db: Database,
  configBuilder: ConfigBuilder,
  syncStates: ReplicationState<unknown>[],
  reSyncTimeouts: NodeJS.Timeout[],
) {
  const stateReplicationState = replicateBorerOperatorState(
    configBuilder,
    syncStates,
    reSyncTimeouts,
  );
  const changeReplicationState = replicateBorerOperatorChange(
    configBuilder,
    syncStates,
    reSyncTimeouts,
  );

  // Special case for handling new items on the borerOperatorStateFeed
  // We toggle showInSchedulerView as false for matching changeState items
  handleOperatorStateFeedEvents(stateReplicationState, changeReplicationState, db);
}
